<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useSpyStore } from '@/stores/spyStore.ts'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import { CDN } from '@/models/cdn.ts'
import StyledImage from '@/components/Elements/Images/StyledImage.vue'

const { t } = useI18n()
const spyStore = useSpyStore()

// Convert Map values to an array and sort by "killed"
const sortedSpies = computed(() =>
  Array.from(spyStore.spies.values())
    .filter(spy => spy.killed === 0 && spy.cost !== 0)
    .sort((a, b) => a.killed - b.killed)
)

</script>

<template>
  <StandardCard top-padding="0" :title="t('government.finances.spies.title')" :help="t('government.finances.spies.help')"></StandardCard>
  <div class="grid md:grid-cols-5 grid-cols-2 sm:grid-cols-3 gap-2 w-full pt-1">
    <template v-for="spy in sortedSpies" :key="spy.id">
      <StandardCard :title="spy.name" top-padding="0">
        <div class="relative">
          <div class="absolute bottom-0 w-full flex items-center justify-center p-2 bg-black/70 z-10">
            <GenericIconWithColoredNumber
                :amount="-spy.cost"
                type="credit"
                :tooltip="t('diplomacy.spies.tooltips.cost')"/>
          </div>
          <div class="overflow-hidden aspect-square">
            <StyledImage :src="CDN.spy(512, spy.imageCode)" size="full" />
          </div>
        </div>
      </StandardCard>
    </template>
  </div>
</template>

<style scoped lang="scss">

</style>